<template>
  <div class="prepareLessons">
    <div class="clearfix top">
      <div class="fl">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="题目编号">
            <el-input v-model="form.code" prefix-icon="el-icon-search" placeholder="请输入题目编号" size="mini" clearable @keyup.enter.native="search"></el-input>
          </el-form-item>
          <el-form-item label="提交状态">
            <el-select v-model="form.result" clearable @change="search">
              <el-option label="全部" value=""></el-option>
              <el-option label="正确" value="0"></el-option>
              <el-option label="错误" value="-1"></el-option>
              <el-option label="编译失败" value="-2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="fl">
        <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>
      </div>
    </div>
    <div class="mian">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }">
        <el-table-column prop="problemCode" label="题目编号"></el-table-column>
        <el-table-column prop="" label="题目名称" width="200">
          <template slot-scope="scope">
            <el-link type="primary" @click="goNext(scope.row)">{{
              scope.row.problemTitle
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="语言">
          <template slot-scope="scope">
            <span v-if="scope.row.language === 0">C</span>
            <span v-if="scope.row.language === 1">C++</span>
            <span v-if="scope.row.language === 2">Python3</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时">
          <template slot-scope="scope">
            <span v-if="scope.row.time_cost === null">0ms</span>
            <span v-else>{{ scope.row.time_cost }}ms</span>
          </template>
        </el-table-column>
        <el-table-column label="内存">
          <template slot-scope="scope">
            <span>{{ scope.row.memory_cost / 1024 }}kb</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_time" label="提交时间" show-overflow-tooltip width="180">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag size="small" :color="programStateEnum[scope.row.result].classifyColor" style="color:#fff;borderColor:transparent">{{programStateEnum[scope.row.result].classifyLabel}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserAllOjSubmissionList } from "@/api/educational.js";
export default {
  data() {
    return {
      page_no: 1,
      page_size: 20,
      total: 20,
      form: {
        code: "",
        result: "",
      },
      tableData: [],
      programStateEnum: {
        '-2': {
          label: '编译失败',
          en: 'CE', // Compile Error
          color: 'rgb(255, 132, 0)',
          classifyLabel: '编译失败',
          classifyColor: 'rgb(255, 132, 0)',
        },
        '-1': {
          label: '程序输出不正确',
          en: 'WA', // Wrong Answer
          color: 'rgb(252, 57, 48)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        0: {
          label: '程序输出正确',
          en: 'AC', // Accept
          color: 'rgb(0, 199, 0)',
          classifyLabel: '正确',
          classifyColor: 'rgb(0, 199, 0)',
        },
        1: {
          label: '时间超限',
          en: 'TLE', // Time Limit Exceeded
          color: 'rgb(0, 35, 68)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        2: {
          label: '时间超限',
          en: 'TLE', // Time Limit Exceeded
          color: 'rgb(0, 35, 68)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        3: {
          label: '内存超限',
          en: 'MLE', // Memory Limit Exceeded
          color: 'rgb(0, 0, 145)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        4: {
          label: '程序运行错误',
          en: 'RE', // Runtime Error
          color: 'rgb(170, 52, 214)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        5: {
          label: '系统错误',
          en: '-',
          color: '#999', // rgb(255, 213, 0)
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        6: {
          label: '等待测评',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        7: {
          label: '测评中',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        8: {
          label: '部分输出正确',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        999: {
          label: '',
          en: '-',
          color: '#999',
          classifyLabel: '未知错误',
          classifyColor: '#999',
        },
      }
    };
  },
  mounted() {
    this.getUserAllOjSubmissionList();
  },
  methods: {
    goNext(row) {
      console.log(row, 12145);
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: row.problem_id,
          type1: "recordOJ",
        },
      });
    },
    search() {
      this.page_no = 1;
      this.getUserAllOjSubmissionList();
    },
    getUserAllOjSubmissionList() {
      getUserAllOjSubmissionList({
        code: this.form.code,
        result: this.form.result,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 1224);
        this.tableData = res.submissionList;
        this.total = res.total;
      });
    },
    handleCurrent(val) {
      this.page_no = val;
      this.getUserAllOjSubmissionList();
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss">
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  //   background: #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
  background: #fff;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

/deep/ .el-dropdown-link {
  cursor: pointer;
  color: #333;
}

.line {
  height: 50px;
  width: 2px;
  background: #999;
  margin: 0 20px;
}

.top li {
  cursor: pointer;
  float: left;
  margin-right: 20px;
}

.active {
  color: #41b146;
}

.topFrom ::v-deep .el-form-item {
  margin-bottom: 0px;
}

.mian {
  margin-top: 10px;
  padding: 10px 10px 10px 10px;

  background: #fff;
  box-sizing: border-box;
}

.txtTable {
  cursor: pointer;
}

.txtTable:hover {
  color: #2e95fb;
}
</style>
